<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row">
        <div class="col-12">
          <div class="btn-group btn-group-justified">
            <button type="button" class="btn btn-outline-secondary" @click="prev">Prev</button>
            <button type="button" class="btn btn-primary" @click="next">Next</button>
          </div>
        </div>
      </div>
      <div class="form-group form-row">
        <div class="col-12">
          <div class="btn-group btn-group-justified">
            <button type="button" class="btn btn-outline-secondary" @click="first">First</button>
            <button type="button" class="btn btn-outline-secondary" @click="last">Last</button>
          </div>
        </div>
      </div>
      <div class="form-group form-row">
        <div class="col-12">
          <p style="text-align:center">Presenter: <a :href="presenterUrl" target="_blank">{{ presenterUrl }}</a></p>
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <album-select-group v-model="albumId" label="Album"></album-select-group>
      <picture-select-group v-model="imageId" :album-id="albumId"
                            label="PDF"></picture-select-group>
      <div class="form-group form-row">
        <label :for="safeId('url')" class="col-sm-4 col-form-label">URL</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('url')" v-model.lazy="url">
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import * as action from '@/store/action-types'
  import { templateMixin } from '@/mixins'
  import { mapOverlayData, mapTemplateData } from '../../utils/index'

  export default {
    name: 'pdf-presentation',
    mixins: [templateMixin],
    computed: {
      ...mapOverlayData(['url']),
      ...mapTemplateData(['albumId', 'imageId']),
      accountId () {
        const selectedAccount = this.$store.getters.selectedAccount
        return selectedAccount ? selectedAccount.accountId : ''
      },
      presenterUrl () {
        const baseUrl = (this.$env.WEBCG_API || '').replace(/ws(s)?:\/\//, 'http$1://')
        const layer = this.$store.getters.template(this.templateId).layer || 0
        return baseUrl + '/presenter/' + this.accountId + '/' + layer
      }
    },
    watch: {
      imageId: function () {
        const image = this.$store.getters.picture(this.albumId, this.imageId) || null
        if (!image) return
        const baseUrl = (this.$env.WEBCG_API || '').replace(/ws(s)?:\/\//, 'http$1://')
        this.url = baseUrl + '/v0/users/' + this.accountId + '/files/' + image.pictureId
      }
    },
    methods: {
      first () {
        this.$store.dispatch(action.COMMAND_INVOKE, {
          templateId: this.templateId,
          channelId: 'program',
          func: 'first()'
        })
        this.$store.dispatch(action.COMMAND_INVOKE, {
          templateId: this.templateId,
          channelId: 'preview',
          func: 'first()'
        })
      },
      prev () {
        this.$store.dispatch(action.COMMAND_INVOKE, {templateId: this.templateId, channelId: 'program', func: 'prev()'})
        this.$store.dispatch(action.COMMAND_INVOKE, {templateId: this.templateId, channelId: 'preview', func: 'prev()'})
      },
      next () {
        this.$store.dispatch(action.COMMAND_NEXT, {templateId: this.templateId, channelId: 'program'})
        this.$store.dispatch(action.COMMAND_NEXT, {templateId: this.templateId, channelId: 'preview'})
      },
      last () {
        this.$store.dispatch(action.COMMAND_INVOKE, {templateId: this.templateId, channelId: 'program', func: 'last()'})
        this.$store.dispatch(action.COMMAND_INVOKE, {templateId: this.templateId, channelId: 'preview', func: 'last()'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/pdf-presentation.vue